import React, { ReactElement } from 'react'

function NotFound(): ReactElement {
    return <div>NOT FOUND</div>
}

export default NotFound
